export class Ufs
{
    id_uf: number = 0;
    sigla_uf: string = '';
    nome_uf: string = '';
    codibge_uf: string = ''
}